type IsDisabledProps = {
  isPlanCardPlanFree: boolean;
  isUserPlanFree: boolean;
  isUserOnLegacyPlan: boolean;
};

export const isDisabled = ({
  isPlanCardPlanFree,
  isUserPlanFree,
  isUserOnLegacyPlan,
}: IsDisabledProps) =>
  isPlanCardPlanFree && isUserPlanFree && !isUserOnLegacyPlan;
